module.exports = __webpack_public_path__ + "assets/1aa5f7a5843c0b112f6b352af574baca.png";